import React from 'react';
import { Field, FieldArray } from 'redux-form';
import { Button } from 'react-bootstrap';
import FormField from '../../../forms/FormField';
import Column from './Column';
import ArrayActions from './ArrayActions';
import ArrayError from './ArrayError';
import AssetFileInput from './AssetFileInput';
import RelationshipInput from './RelationshipInput';
import AssetTags from './AssetTags';

import {
  RenderSelectValue,
  RenderValue,
  RenderRelationshipValue,
  RenderFile,
  RenderSwitchValue,
  RenderVideoValue,
  RenderWysiwyg
} from './ReadOnlyFields';

const getValidation = (validate = []) => {
  return validate.map(v => {
    return new Function(`return ${v}`)();
  });
};

const FieldSwitch = ({ field, name, hideLabel, readOnly }) => {
  const { opts, type } = field || {};
  const validate = getValidation(opts.validate);
  const label = !hideLabel && !opts.hideLabel && opts.label;
  const { inputProps, labelStyle } = opts || {};
  switch (type) {
    case 'select': {
      return (
        <Field
          name={name || opts.name}
          type="text"
          component={readOnly ? RenderSelectValue : FormField.Select2}
          options={opts.options}
          label={label}
          placeholder={opts.placeholder || ''}
          validate={validate}
          {...inputProps}
          labelStyle={labelStyle}
        />
      );
    }
    case 'textarea': {
      return (
        <Field
          name={name || opts.name}
          rows={opts.rows || 5}
          componentClass="textarea"
          component={readOnly ? RenderValue : FormField.Input}
          label={label}
          validate={validate}
          style={{ resize: 'vertical' }}
          labelStyle={labelStyle}
        />
      );
    }
    case 'file': {
      return (
        <Field
          name={name || opts.name}
          field={field}
          type="text"
          component={readOnly ? RenderFile : AssetFileInput}
          label={label}
          placeholder={opts.placeholder || ''}
          validate={validate}
          labelStyle={labelStyle}
        />
      );
    }
    case 'relationship': {
      return (
        <Field
          name={name || opts.name}
          field={field}
          type="text"
          component={readOnly ? RenderRelationshipValue : RelationshipInput}
          label={label}
          placeholder={opts.placeholder || ''}
          validate={validate}
          labelStyle={labelStyle}
        />
      );
    }
    case 'boolean': {
      return (
        <Field
          name={name || opts.name}
          field={field}
          component={readOnly ? RenderSwitchValue : FormField.Switch}
          label={label}
          placeholder={opts.placeholder || ''}
          validate={validate}
          labelStyle={labelStyle}
        />
      );
    }
    case 'video': {
      return (
        <Field
          name={name || opts.name}
          type="text"
          component={readOnly ? RenderVideoValue : FormField.Input}
          label={label}
          placeholder={opts.placeholder || ''}
          validate={validate}
          labelStyle={labelStyle}
        />
      );
    }
    case 'wysiwyg': {
      return (
        <Field
          name={name || opts.name}
          type="text"
          component={readOnly ? RenderWysiwyg : FormField.Wysiwyg}
          label={label}
          placeholder={opts.placeholder || ''}
          validate={validate}
          labelStyle={labelStyle}
        />
      );
    }
    case 'tags': {
      return (
        <Field
          name={name || opts.name}
          rootName={name || opts.name}
          component={AssetTags}
          label={label}
          readOnly={readOnly}
          color={opts.color || null}
          labelStyle={labelStyle}
        />
      );
    }
    default: {
      return (
        <Field
          name={name || opts.name}
          type="text"
          component={readOnly ? RenderValue : FormField.Input}
          label={label}
          placeholder={opts.placeholder || ''}
          validate={validate}
          labelStyle={labelStyle}
        />
      );
    }
  }
};

const RenderFieldsArray = ({ fields, field, meta, readOnly }) => {
  const addField = () => fields.push();
  const { opts } = field || {};
  return (
    <div>
      <div className="form-section-add">
        {!readOnly &&
          <div className="pull-right">
            <Button
              onClick={addField}
              bsStyle="hollow-info"
              bsSize="sm"
              className="pull-right"
            >
              <span className="ti ti-plus" />
              {' '}
              {opts.arrayButtonText || 'section'}
            </Button>
          </div>}
        {!opts.hideLabel && <h3>{opts.label}</h3>}
      </div>
      {!readOnly && <ArrayError {...meta} />}
      <div className="clearfix">
        {fields.map((f, index) => {
          return (
            <div key={index}>
              {!readOnly &&
                <div className="section-actions small">
                  <ArrayActions fields={fields} index={index} />
                </div>}
              <h5>Image #{index + 1}</h5>
              <FieldSwitch
                field={field}
                name={f}
                hideLabel
                readOnly={readOnly}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

const FieldSection = ({ field, readOnly }) => {
  const { opts } = field || {};

  if (opts.isArray) {
    return (
      <Column field={field}>
        <FieldArray
          name={opts.name}
          component={RenderFieldsArray}
          props={{ field }}
          readOnly={readOnly}
        />
        {opts.helpText &&
          <div className="note">
            {opts.helpText}
          </div>}
      </Column>
    );
  }
  return (
    <Column field={field}>
      <FieldSwitch field={field} readOnly={readOnly} />
      {opts.helpText &&
        <div className="note">
          {opts.helpText}
        </div>}
    </Column>
  );
};

export default FieldSection;



// WEBPACK FOOTER //
// ./src/components/routes/assets/asset-form/FieldSection.js